module.exports = __webpack_public_path__ + "static/graphql-ce8dad37a9588e1e199c660f4ffcdf5e.svg";